/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

// 本番環境
const awsmobile = {
  Auth: {
    aws_project_region: "ap-northeast-1",
    region: "ap-northeast-1",
    userPoolId: "ap-northeast-1_QgZNV92p6", 
    userPoolWebClientId: "2r2oedj03i8mkn1dl30kaiflgv",     
  },
  API: {
    endpoints: [
      {
        name: "usersite-prod-api-phase2",
        endpoint:
          "https://n3yttu3d62.execute-api.ap-northeast-1.amazonaws.com/prod_stage"
      },
    ]
  }
};

export default awsmobile;
  


// WEBPACK FOOTER //
// ./src/aws-exports.js